import axios from 'axios';

const DEFAULT_API_URL = process.env.NODE_ENV === 'development'
  ? 'http://127.0.0.1:4000'
  : '';
const API_BASE_URL = process.env.REACT_APP_API_URL || DEFAULT_API_URL;

const API = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
});

API.interceptors.request.use(cfg => {
  const token = localStorage.getItem('token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

API.interceptors.response.use(
  r => r.data,
  e => Promise.reject(e.response?.data?.error || e.message || '')
);

export default API;

// WebSocket
export function createWS() {
  const wsUrl = getWsUrl();
  try {
    const url = new URL(wsUrl);
    if (url.hostname === 'localhost') url.hostname = '127.0.0.1';
    return new WebSocket(url.toString());
  } catch {
    return new WebSocket(wsUrl);
  }
}

function getWsUrl() {
  if (API_BASE_URL) return API_BASE_URL.replace(/^http/, 'ws');
  if (typeof window === 'undefined') return 'ws://127.0.0.1:4000';

  const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  return `${protocol}//${window.location.host}/api/`;
}

//  localStorage  ID
export function getDeviceFingerprint() {
  let fp = localStorage.getItem('device_fp');
  if (!fp) {
    fp = 'fp_' + Math.random().toString(36).slice(2) + Date.now().toString(36);
    localStorage.setItem('device_fp', fp);
  }
  return fp;
}
